var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfoI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3998 18.8835C10.3998 16.2622 10.4038 13.7198 10.3898 11.1774C10.3898 11.0293 10.2795 10.8511 10.1653 10.74C9.631 10.2208 9.44757 9.58766 9.72021 8.973C10.0059 8.32913 10.5301 8.00865 11.2518 7.99793C11.4523 7.99501 11.6518 7.99598 11.8522 7.99793C12.9398 8.00572 13.5973 8.63499 13.5993 9.68994C13.6034 12.5567 13.6013 15.4225 13.6013 18.2893C13.6013 18.4656 13.6013 18.6409 13.6013 18.8835C13.889 18.8835 14.1486 18.8767 14.4082 18.8845C15.3074 18.9137 15.998 19.5887 16 20.4343C16.002 21.2807 15.3144 21.9782 14.4153 21.987C12.7985 22.0035 11.1806 22.0055 9.56484 21.986C8.67174 21.9753 7.98813 21.2603 8.00016 20.4138C8.01218 19.5839 8.68477 18.9215 9.56083 18.8854C9.82245 18.8747 10.0861 18.8835 10.3998 18.8835Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9956 1.00001C13.3267 0.997084 14.4093 2.05593 14.4003 3.35051C14.3913 4.62073 13.3157 5.66107 12.0066 5.66302C10.6775 5.66594 9.59295 4.60515 9.60197 3.31252C9.60999 2.04229 10.6875 1.00293 11.9956 1.00001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoI);
export default __webpack_public_path__ + "static/media/icon-info-i.035e0edb87bf473f7b9dbbd2e86212db.svg";
export { ForwardRef as ReactComponent };